import { FC } from "react";

const Union: FC<{ active?: boolean }> = ({ active }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_333_123)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.9334 5.3328C3.9334 3.08684 5.75411 1.26613 8.00007 1.26613C10.246 1.26613 12.0667 3.08684 12.0667 5.3328C12.0667 6.74518 11.3467 7.9894 10.2537 8.71841C10.2174 8.73694 10.1833 8.75901 10.152 8.78411C9.52782 9.17409 8.79026 9.39946 8.00007 9.39946C5.75411 9.39946 3.9334 7.57876 3.9334 5.3328ZM10.0451 10.1877C9.41637 10.4529 8.72534 10.5995 8.00007 10.5995C7.27483 10.5995 6.58383 10.4529 5.95508 10.1877L5.42507 14.1781L7.69104 12.8186C7.88105 12.7045 8.11843 12.7045 8.30844 12.8186L10.5746 14.1782L10.0451 10.1877ZM4.83065 9.53943C3.55679 8.57815 2.7334 7.05163 2.7334 5.3328C2.7334 2.4241 5.09137 0.0661316 8.00007 0.0661316C10.9088 0.0661316 13.2667 2.4241 13.2667 5.3328C13.2667 7.05156 12.4434 8.57802 11.1696 9.53931L11.9279 15.2541C11.9582 15.4825 11.855 15.7081 11.6625 15.8345C11.4699 15.961 11.2219 15.9661 11.0244 15.8475L7.99974 14.0328L4.9751 15.8475C4.77754 15.9661 4.52955 15.961 4.33698 15.8345C4.14442 15.708 4.04129 15.4824 4.07163 15.254L4.83065 9.53943Z"
          fill={active ? "white" : "#131720"}
        />
      </g>
      <defs>
        <clipPath id="clip0_333_123">
          <rect
            y="-0.000366211"
            width="16"
            height="16"
            rx="8"
            fill={active ? "white" : "#131720"}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Union;
